import FilterDialog from './Dialog';
import { useSelector } from 'react-redux';
import FilterButton from '../../../../../filter/FilterButton';

const FilterStudentsButtom = ({ disabled = false, dataYears = [] }) => {
  const open = useSelector((state) => state?.filter?.assessmentStudentsList?.open || false);

  return (
    <>
      <FilterButton module='assessmentStudentsList' keysFilter={['yearLevelId', 'rolesId', 'code']} disabled={disabled} />
      {open && !disabled && (
        <FilterDialog dataYears={dataYears} />
      )}
    </>
  );
};
export default FilterStudentsButtom;
